import { render, staticRenderFns } from "./InternalRequestbyResponsable.vue?vue&type=template&id=31fa8fe6&"
import script from "./InternalRequestbyResponsable.vue?vue&type=script&lang=js&"
export * from "./InternalRequestbyResponsable.vue?vue&type=script&lang=js&"
import style0 from "./InternalRequestbyResponsable.vue?vue&type=style&index=0&id=31fa8fe6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports